<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { usePlayerStore } from '~/stores/player'
import ShellToasts from '~/components/mm/shell/ShellToasts.vue'
import ShellTopNav from '~/components/mm/shell/ShellTopNav.vue'
import ShellFooter from '~/components/mm/shell/ShellFooter.vue'
import ShellTabBar from '~/components/mm/shell/ShellTabBar.vue'
import PlayerDock from '~/components/mm/shell/PlayerDock.vue'
import NowPlayingSheet from '~/components/mm/shell/NowPlayingSheet.vue'
const { t } = useI18n()
const player = usePlayerStore()
useHead(() => ({ htmlAttrs: { style: `--live-h: ${player.shellHue}` } }))
const route = useRoute()
const toolHues: Record<string, number> = { '/lyrics-generator': 46, '/rap-lyrics-generator': 14, '/rap-name-generator': 330 }
watch(() => route.path, path => player.setPageHue(toolHues[path.replace(/\/$/, '')]), { immediate: true })
const openMenus = useState('mm-open-menus', () => 0)
const keyboardOpen = ref(false)
const toastHeight = ref(0)
const updateKeyboard = () => {
  const viewport = window.visualViewport
  const editing = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]')
  keyboardOpen.value = !!(viewport && editing && window.innerWidth < 1024 && window.innerHeight - viewport.height > 150)
}
onMounted(() => {
  window.visualViewport?.addEventListener('resize', updateKeyboard)
  document.addEventListener('focusin', updateKeyboard)
  document.addEventListener('focusout', updateKeyboard)
})
onBeforeUnmount(() => {
  player.setPageHue()
  window.visualViewport?.removeEventListener('resize', updateKeyboard)
  document.removeEventListener('focusin', updateKeyboard)
  document.removeEventListener('focusout', updateKeyboard)
})
</script>

<template>
  <div class="app-shell" :style="{ '--toast-height': `${toastHeight}px` }" :class="{ 'has-played': player.hasPlayedThisSession, 'has-open-menu': openMenus > 0, 'has-player': player.visible, 'is-create': route.path === '/create', 'is-feed': route.path === '/feed', 'is-checkout': /^\/(checkout|payment)\//.test(route.path), 'keyboard-open': keyboardOpen }">
    <a class="skip" href="#main">{{ t('mm.shell.skip') }}</a>
    <div class="aura" aria-hidden="true" />
    <ShellTopNav />
    <main id="main" class="shell-content" tabindex="-1"><slot /></main>
    <ShellFooter />
    <ShellTabBar v-if="!/^\/(checkout|payment)\//.test(route.path)" />
    <PlayerDock :immersive="route.path === '/feed'" />
    <NowPlayingSheet />
    <ShellToasts @resize="toastHeight = $event" />
    <UpgradeDialog />
  </div>
</template>
